export const ACTUALIZAR_LIST_NIVEL2 = "ACTUALIZAR_LIST_NIVEL2";
export const MODIFICAR_NIVEL2 = "MODIFICAR_NIVEL2";
export const AGREGAR_NIVEL2 = "AGREGAR_NIVEL2";  
export const ELIMINAR_NIVEL2 = "ELIMINAR_NIVEL2";